import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { LookupService } from 'src/app/Services/Common/lookup.service';
import { HrService } from 'src/app/services/hr/hr.service';

@Component({
  selector: 'app-staff-shift-mapping',
  templateUrl: './staff-shift-mapping.component.html',
  styleUrls: ['./staff-shift-mapping.component.css']
})
export class StaffShiftMappingComponent implements OnInit {
  EmployeeTypeList = [];
  Submitted: boolean = false;
  Designation = [];
  EmployeeList = [];
  ShiftList = [];
  EmployeeCategoryList = [];

  constructor(private payrollService: HrService, private lookupservice: LookupService, public globalHelper: GlobalHelper,
    private spinnerService: Ng4LoadingSpinnerService) { }

  EmployeeSalaryMappingModel = {
    StaffID: 0,
    SalaryComponentID: 0,
    MonthlyEntitlement: 0,
    EmployeeCategoryID: 0,
    DesignationID: 0,
    StaffIdentity: '',
  }

  searchStaffModel = {
    StaffID: 0,
    SalaryComponentID: 0,
    MonthlyEntitlement: 0,
    EmployeeCategoryID: 0,
    DesignationID: 0,
    StaffIdentity: '',


  }

  GetEmployeeType() {

    this.lookupservice.GetLookupsList('EmployeeType', '').subscribe((data: any) => {
      this.EmployeeTypeList = data.LookupItems;
    });
  };

  GetDesignation() {
    this.lookupservice.GetLookupsList('Designation', '').subscribe((data: any) => {
      this.Designation = data.LookupItems;
    });
  };

  GetAllEmployeeCategory() {
    this.lookupservice.GetLookupsList('EmployeeCategory', '').subscribe((data: any) => {
      this.EmployeeCategoryList = data.LookupItems;
    });

  }




  SaveEmployeeShift() {

    this.spinnerService.show();
    this.payrollService.SaveEmployeeShift(JSON.stringify(this.EmployeeList)).subscribe((response: any) => {
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(response);
      this.GetAllEmployeeShift();
    });
  };

  GetAllEmployeeShift() {
    this.spinnerService.show();
    this.payrollService.GetAllEmployeeShift(JSON.stringify(this.searchStaffModel)).subscribe((data: any) => {

      this.EmployeeList = data.EmployeeList;
      this.ShiftList = data.ShiftList;
      this.spinnerService.hide();


    });
  };

  SelectChange(list, IsActive, k) {
    for (var i = 0; i < list.length; i++) {
      list[i].IsActive = false;
    }
    IsActive = IsActive == true ? false : true
    if (IsActive) {
      list[k].IsActive = false;
    }
    else {
      list[k].IsActive = true;
    }




  }


  Clear() {
    this.searchStaffModel.EmployeeCategoryID = 0;
    this.searchStaffModel.DesignationID = 0;
    this.searchStaffModel.StaffIdentity = '';
    this.EmployeeList = [];

  }

  ngOnInit() {
    this.GetAllEmployeeCategory();
    this.GetEmployeeType();
    this.GetAllEmployeeShift();
  }

}
